/**
 * Interpreta el flag cliente_neto del pedido (meta / extraDetails).
 */
export function parseClienteNetoFlag(raw: unknown): boolean {
  if (raw === true) return true
  if (raw === false) return false
  if (typeof raw === 'number') return raw === 1
  if (raw != null && raw !== '') {
    const v = String(raw).trim().toLowerCase()
    return v === '1' || v === 'true'
  }
  return false
}
